/**
 * True when a media URL is something the browser can load into an `<img>`.
 * Two valid shapes reach the public dancer view (gallery blank-tiles regression):
 *   - absolute `http(s)://…` — a live Supabase signed URL (authenticated view)
 *     or a legacy Meteor/S3 URL;
 *   - same-origin absolute path `/api/media/cover/original/<base64>` — the
 *     stable, token-free proxy URL the CACHED anonymous loader
 *     (`getCachedPublicDancer`) emits by design (commit 35f798d650). It 302s to
 *     a fresh signed URL, so the browser resolves it fine.
 *
 * An authority-relative URL is NOT same-origin — it resolves against a foreign
 * host — so it is rejected here even though it starts with `/`. This covers both
 * `//host/…` and `/\host/…`: for `http(s)` the WHATWG URL parser normalizes a
 * backslash to a slash, so `/\evil.example` resolves to `https://evil.example`.
 * We therefore reject any URL whose second character opens an authority (`/` or
 * `\`). Raw `storage_path` (no scheme, no leading slash) and empty string are
 * NOT fetchable. Kept in this pure, dependency-free module so BOTH the gallery
 * tile guard and the lightbox filter import the SAME predicate — the divergence
 * (hero rendered the URL, gallery's http-only guard did not) is what left every
 * anonymous profile gallery blank.
 */
export function isRenderableMediaUrl(url: string): boolean {
  return (
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    (url.startsWith('/') && url[1] !== '/' && url[1] !== '\\')
  );
}
